import { ModuleType } from '../../types/modules';
import { AppState } from '../../types/store';
import { getModuleDataByModuleType } from './modules';
import {
  getDeviationById,
  getDeviationsByIds,
} from '@wix/da-shared-react/pkg/redux/deviations/selectors';

export const getSelectedTierContentType = (state: AppState) =>
  state.subscriptionsSection.tierContentType;

export const getSelectedTierEntityId = (state: AppState) =>
  state.subscriptionsSection.selectedTierEntityId;

export const getSelectedTier = (state: AppState) => {
  const selectedTierEntityId = getSelectedTierEntityId(state);
  if (!selectedTierEntityId) {
    return undefined;
  }
  return getDeviationById(state, selectedTierEntityId);
};

export const hasPublishedTiers = (state: AppState) => {
  const tiers = getModuleDataByModuleType(state, ModuleType.TIERS)?.tiers;
  if (!tiers || !tiers?.length) {
    return false;
  }
  return getDeviationsByIds(state, tiers).some(tier => tier.isPublished);
};

export const getSelectedOrFirstTier = (state: AppState) => {
  let tierEntityId = getSelectedTierEntityId(state);
  if (!tierEntityId) {
    tierEntityId = getModuleDataByModuleType(state, ModuleType.TIERS)?.tiers[0];
  }
  return tierEntityId ? getDeviationById(state, tierEntityId) : undefined;
};

export const getSubscriptionsStats = (state: AppState) =>
  state.subscriptionsSection.stats;

export const getSubscriptionsChartData = (state: AppState) =>
  state.subscriptionsSection.chartData;
